import s from "./style.module.css";
import { preventSamePageNavigation } from "@/utils/navigation";
export interface Input extends Marko.HTML.A {
    label: string;
    color: string;
}

<a/ref
    ...input
    class=[input.class, s.link]
    data-color=input.color
    data-active=`${$global.url.pathname === input.href}`
    onClick(e) {
        preventSamePageNavigation(e, ref());
    }>
    <span class=s.svg>
        <svg viewBox="0 0 32 32" width=32 height=32>
            <path
                d="M 4 16 L 28 16 L 16 4 M 28 16 L 16 28"
                fill="none"
                stroke-width="3.5"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
    </span>
    <span class=s.word>
        ${input.label}
    </span>
    // <span class=s.line>
    //     <for|letter, i| of=input.label.split("")>
    //         <if=letter.trim() === "">
    //             ${letter}
    //         </if>
    //         <else>
    //             <span class=s.letter style=`--index: ${i}`>
    //                 ${letter}
    //             </span>
    //         </else>
    //     </for>
    // </span>
</a>
